// extracted by mini-css-extract-plugin
export default {"formSubtitle":"ir5fLIJCIjVtr9nU2ben","divider":"kdSGKmTnorJlTzFDRfSU","dividerVertical":"gZ5kOG_J8MA8WrbzHPFI"};